export default __webpack_public_path__ + "static/media/Bell_White.e5e9166d.svg";